<script lang="ts" setup>
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';


//servicos
import * as service from "@/services/clienteService";
import { corrigirImagensContrato } from "@/utils/funcoes";

//componentes

import imgLogin from "@/assets/images/logoLogin.png";

const route = useRoute();

var controle = reactive({
  contratoId: 0,
  model: {} as service.Contrato,


  status: "",
  erro: "",
})

onMounted(async () => {
  pesquisar();
})

async function pesquisar() {

  console.log("busca contrato", controle.contratoId);
  if (route.params.contratoId) {
    controle.contratoId = parseInt(route.params.contratoId as string);
  }

  service.obterDados()
    .then(r => {
      console.log(r);
      controle.model = r.contratos.find(c => c.contratoId == controle.contratoId) as service.Contrato;
    })
    .catch(erro => {
      controle.erro = erro;
    })
}

</script>

<template>


  <div class="row mt-4">
    <div class="col-md-12 text-center">
      <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
      <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="row">
          
            <div class="col-md-4">
            <h5 class="card-title"><strong>Número do Contrato:</strong> {{ controle.model.contratoId }}</h5>
          </div>
          <div class="col-md-4">
            <h5 class="card-title"><strong>Plano:</strong> {{ controle.model.plano?.nome }}</h5>
          </div>
          <div class="col-md-4">
            <h5 class="card-title"><strong>Data de Assinatura:</strong> {{ controle.model.dataAssinatura ? new Date(controle.model.dataAssinatura).toLocaleDateString() : 'Não assinado' }}</h5>
          </div>
      </div>
      <p class="card-text"></p>
      <p class="card-text"></p>
      <p class="card-text"></p>

      <div class="mb-4 pb-4 bg-white" v-html="corrigirImagensContrato(controle.model.texto)"></div>
      </div>
  </div>



  <nav class="navbar fixed-bottom navbar-light p-2" style="background-color: #e3f2fd">
    <form class="container justify-content-start">
      <RouterLink class="btn btn-primary btn-sm me-2" type="button" :to="{ name: 'PainelCliente' }">Voltar</RouterLink>
      <RouterLink class="btn btn-warning btn-sm " type="button" v-if="controle.model.dataAssinatura == null"
        :to="{ name: 'PainelClienteAssinarContrato', params: { contratoId: controle.contratoId } }">Assinar</RouterLink>
    </form>
  </nav>

</template>

<style lang="css" scoped>
.img-logo {
  max-width: 300px;
}
</style>